module.exports = {
  siteTitle: "HeroBlog - a GatsbyJS starter", // <title>
  shortSiteTitle: "HeroBlog - GatsbyJS starter", // <title> ending for posts and pages
  siteDescription: "HeroBlog is a GatsbyJS starter.",
  siteUrl: "https://gatsby-starter-hero-blog.greglobinski.com",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "greg lobinski",
  authorTwitterAccount: "greglobinski",

  /* info */
  headerTitle: "malufi",
  headerSubTitle: "mobile homes",

  /* manifest.json */
  manifestName: "HeroBlog - a GatsbyJS starter",
  manifestShortName: "HeroBlog", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/greglobinski" },
    { name: "twitter", url: "https://twitter.com/greglobinski" },
    { name: "facebook", url: "http://facebook.com/greglobinski" }
  ]
};
